import React from "react";
import { LogoStyled } from "./styles/Styled";

export default ({ height }) => {
  return (
    <LogoStyled
      src={`https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/images/logos/starzon/new/tvs/starzplay-logo.svg`}
      alt="Logo"
      height={height}
    />
  );
};
